/**
 * Common validation rules for Objects used across form components
 */

export const PREFIX = /^l(c)?:/

export const OBJECT_LABEL_VALIDATION = {
	/**
	 * Validates that a label starts with "l:" or "lc:"
	 */
	LABEL_PREFIX: {
		pattern: PREFIX,
		message: 'Label must start with "l:" or "lc:"',
	},
} as const

/**
 * Common validation messages
 */
export const OBJECT_VALIDATION_MESSAGES = {
	LABEL_REQUIRED: "Label is required",
	NAME_REQUIRED: "Name is required",
	TOP_LEVEL_CATEGORY_REQUIRED: "Top level category is required",
	SUPER_CATEGORY_REQUIRED: "Super category is required",
	COLUMNS_REQUIRED: "Columns is required",
} as const
